import { ForbiddenError } from "@src/features/auth/services/authenticated-fetch";
import { ApiError, ApiTimeoutError } from "@src/services/api/request";
const GENERIC = "Something went wrong. Please try again.";
const NETWORK = "Please check your connection and try again.";
const FORBIDDEN = "You don't have permission to perform this action.";

const isUnauthorised = (e: unknown): e is { status: 403 } =>
  e instanceof ForbiddenError || (e instanceof ApiError && e.status === 403);

const isNetwork = (e: unknown): boolean => e instanceof ApiTimeoutError || (e instanceof ApiError && e.status === 0);

const rules: ReadonlyArray<(e: unknown) => string | null> = [
  (e) => (isUnauthorised(e) ? FORBIDDEN : null),
  (e) => (isNetwork(e) ? NETWORK : null),
];

export function getErrorMessage(error: unknown): string {
  return rules.map((r) => r(error)).find((m) => m !== null) ?? GENERIC;
}
